import {defineCssVars, defineStyleConfig} from '@chakra-ui/styled-system';

export const {fontSize: $fontSize} = defineCssVars(`paginationGroup`, [`fontSize`]);

export const groupCssVars = {
  [$fontSize.variable]: `inherit`,
};

export const groupStyle = defineStyleConfig({
  baseStyle: {
    [`& > * `]: {
      marginInlineStart: `0`,
    },
    [`& > [data-part="prev-page-trigger"]`]: {
      borderTopRightRadius: `0`,
      borderBottomRightRadius: `0`,
    },
    [`& > [data-part="next-page-trigger"]`]: {
      borderTopLeftRadius: `0`,
      borderBottomLeftRadius: `0`,
    },
  },
  sizes: {},
});
